<template>
  <multiselect
    placeholder="Type to search"
    style="min-width: 100px"
    selectLabel
    v-model="selected"
    multiple
    :closeOnSelect="false"
    @close="update"
    @remove="removeAndUpdate"
    :searchable="true"
    :options="options"
    :label="labelKey"
    :trackBy="trackByKey"
  >
    <span slot="noResult">No results.</span>
    <template slot="placeholder">
      <span class="text-secondary"> {{ placeholder }} </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'GenericMultiSelect',
  components: {
    Multiselect
  },
  props: {
    placeholder: {
      type: String,
      default: 'All options'
    },
    init: {
      type: Array
    },
    options: {
      type: Array,
      required: true
    },
    labelKey: {
      type: String,
      default: null
    },
    trackByKey: {
      type: String,
      default: null
    },
    emitKey: {
      type: String,
      default: null
    }
  },
  data: () => ({
    selected: []
  }),
  mounted() {
    if (this.init) {
      this.selected = this.init
    }
  },
  methods: {
    reset() {
      this.selected = []
    },
    removeAndUpdate(option) {
      const filteredSelected = this.selected.filter((s) => s !== option)
      this.$emit('update', this.getEmitValue(filteredSelected))
    },
    update() {
      this.$emit('update', this.getEmitValue(this.selected))
    },
    getEmitValue(selectedItems) {
      if (!this.emitKey || !selectedItems.length) {
        return selectedItems
      }
      return selectedItems.map((item) => item[this.emitKey])
    }
  }
}
</script>
